<template>
    
    <div class="main">        
        <list></list>            
    </div>
    
</template>
<script>

import list from "./list"

export default {
    components:{ list }
}
</script>
